<template>
  <div class="menu-bar">

    <ul>
      <li class="menu-item"><label>File</label></li>
      <li class="menu-item"><label>View</label></li>
      <li class="menu-item"><label>Special</label>
        <!--<ul class="dropdown">-->
          <!--<li data-cmd="showPalette" data-arg="colors"><label>Colors...</label></li>-->
          <!--<li data-cmd="showPalette" data-arg="line-widths"><label>Line Widths...</label></li>-->
          <!--<li data-cmd="showPalette" data-arg="brushes"><label>Brush Shapes...</label></li>-->
        <!--</ul>-->
      </li>
    </ul>

  </div>
</template>

<style lang="scss">
  // see menubar.scss
</style>

<script>

  export default{
    data(){
      return {
      }
    },

    ready() {
    },

    beforeDestroy() {
    },

    methods: {
      thisIsAllFake() {
        return true;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// DosFileMenu.vue?0f3ead5b